<template>
  <VueFinalModal
    :esc-to-close="true"
    class="flex justify-center items-center"
    content-class="relative flex flex-col w-[600px] mx-auto bg-white border rounded-lg"
  >
    <interactive-google-maps :interactiveMapData="params.data" :apiKey="apiKey"/>
  </VueFinalModal>
</template>

<script setup>
  import { VueFinalModal } from 'vue-final-modal'
  import InteractiveGoogleMaps from '../components/InteractiveGoogleMaps.vue'
  import { inject, onMounted } from 'vue'

  const props = defineProps({
    params: Object,
  })

  const emit = defineEmits(['close'])

  const apiKey = inject('apiKey')

  onMounted(() => {
    console.log('onMounted', props.params.kestrelEnabled)
  })
</script>

<style>
</style>
